var _g, _g2, _path, _g3, _g4, _g5, _g6, _path2, _g7, _path3, _g8, _path4, _g9, _g10, _g11, _path5, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _path6, _g27, _g28, _g29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKickEveryoneOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 60,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "1.8 2.0 60.2 60.0",
    width: 60.2,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m50.63 35v4.28a1.18 1.18 0 0 1 -1.18 1.18h-5.37a1.18 1.18 0 0 0 -1.18 1.18v.82a1.18 1.18 0 0 1 -1.18 1.18h-1.56a1.18 1.18 0 0 1 -1.16-1.16 1.18 1.18 0 0 0 -1.2-1.18h-4.17a.46.46 0 0 1 -.46-.46v-3.2a1.18 1.18 0 0 0 -1.17-1.18 5.88 5.88 0 0 0 -5.88 5.88v1.05a1.18 1.18 0 0 1 -1.18 1.18h-2.14a1.18 1.18 0 0 1 -1.18-1.18v-5.15a1.18 1.18 0 0 0 -1.18-1.18h-5.88a1.18 1.18 0 0 1 -1.18-1.18v-6.54a1.18 1.18 0 0 0 -1.18-1.18h-8a1.18 1.18 0 0 0 -1.2 1.18v30.48a1.18 1.18 0 0 0 1.18 1.18h55.64a1.18 1.18 0 0 0 1.18-1.18v-24.82a1.18 1.18 0 0 0 -1.18-1.18h-8a1.18 1.18 0 0 0 -1.19 1.18z",
    fill: "#d9ebf4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#e1eef4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.74 7.56a.64.64 0 0 0 -.64-.64h-3.4a1.06 1.06 0 0 0 -1.06 1.08 1.06 1.06 0 0 0 1.06 1h1.7a.64.64 0 0 1 .64.64.64.64 0 0 0 .64.64h3.4a1.06 1.06 0 0 0 1.06-1.06 1.06 1.06 0 0 0 -1.06-1.02h-1.7a.64.64 0 0 1 -.64-.64z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.8 12.36a.37.37 0 0 1 .37-.36h2a.62.62 0 0 1 .62.62.62.62 0 0 1 -.62.62h-1a.37.37 0 0 0 -.37.37.37.37 0 0 1 -.37.37h-2a.62.62 0 0 1 -.62-.62.62.62 0 0 1 .62-.62h1a.37.37 0 0 0 .37-.38z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 22.44,
    fill: "inherit",
    r: 0.89
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.12,
    cy: 14.6,
    fill: "inherit",
    r: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.37,
    cy: 16.34,
    fill: "inherit",
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.2,
    cy: 5.68,
    fill: "inherit",
    r: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.2,
    cy: 16.34,
    fill: "inherit",
    r: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.3,
    cy: 23.54,
    fill: "inherit",
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.32,
    cy: 10.92,
    fill: "inherit",
    r: 0.49
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 61h58",
    fill: "none",
    stroke: "#041256",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m35.61 3h23.39a2 2 0 0 1 2 2v56a0 0 0 0 1 0 0h-27.41a0 0 0 0 1 0 0v-56a2 2 0 0 1 2.02-2z",
    fill: "#d88298"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m57 7v50h-19.41v-50zm2-4h-23.39a2 2 0 0 0 -2 2v56h27.39v-56a2 2 0 0 0 -2-2z",
    fill: "#cc6a7f"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m61 59.84v-24.84a1.18 1.18 0 0 0 -1.18-1.16h-8a1.18 1.18 0 0 0 -1.19 1.16v4.28a1.18 1.18 0 0 1 -1.18 1.18h-5.37a1.18 1.18 0 0 0 -1.18 1.18v.82a1.18 1.18 0 0 1 -1.18 1.18h-1.56a1.18 1.18 0 0 1 -1.16-1.16 1.18 1.18 0 0 0 -1.2-1.18h-4.21v19.7h26.23a1.18 1.18 0 0 0 1.18-1.16z",
    fill: "#a58"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m59.82 33.83h-2.82v23.17h-19.41v-15.7h-4v19.7h26.23a1.18 1.18 0 0 0 1.18-1.16v-24.84a1.18 1.18 0 0 0 -1.18-1.17z",
    fill: "#964e7c"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m35.61 3h23.39a2 2 0 0 1 2 2v56a0 0 0 0 1 0 0h-27.41a0 0 0 0 1 0 0v-56a2 2 0 0 1 2.02-2z",
    fill: "none",
    stroke: "#041256",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m40.46 23.94h.54a5.65 5.65 0 0 1 3.67 1.35l.08.07a.77.77 0 0 1 .09 1.08l-.18.22a1.64 1.64 0 0 1 -1.26.59h-1.4a3.5 3.5 0 0 1 -2.79-1.39z",
    fill: "#dda183"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m40.46 23.94h.54a5.65 5.65 0 0 1 3.67 1.35l.08.07a.77.77 0 0 1 .09 1.08l-.18.22a1.64 1.64 0 0 1 -1.26.59h-1.4a3.5 3.5 0 0 1 -2.79-1.39z",
    fill: "none",
    stroke: "#041256",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.58 35.86h-.58a5.65 5.65 0 0 0 -3.67 1.35l-.08.07a.77.77 0 0 0 -.09 1.08l.18.22a1.64 1.64 0 0 0 1.26.59h1.4a3.5 3.5 0 0 0 2.79-1.39z",
    fill: "#dda183"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m7.58 35.86h-.58a5.65 5.65 0 0 0 -3.67 1.35l-.08.07a.77.77 0 0 0 -.09 1.08l.18.22a1.64 1.64 0 0 0 1.26.59h1.4a3.5 3.5 0 0 0 2.79-1.39z",
    fill: "none",
    stroke: "#041256",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m37 53.58 1.77 1.16a2.17 2.17 0 0 1 1 1.58l.44 3.93a.67.67 0 0 1 -.67.75 1.86 1.86 0 0 1 -1.54-.86l-3.11-4.84z",
    fill: "#041256"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m31.67 33 1.33 10.58a2.15 2.15 0 0 0 .18.61l4.16 9a1.35 1.35 0 0 1 -.09 1.18c-1.2 1.8-3.18 1.53-4 .28l-14.09-22.45z",
    fill: "#192763"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m35.66 55.21a1.35 1.35 0 0 0 .09-1.21l-4.16-9a2.15 2.15 0 0 1 -.18-.61l-1.33-10.6-10.31-.64-.62-1 12.52.85 1.33 10.58a2.15 2.15 0 0 0 .18.61l4.16 9a1.35 1.35 0 0 1 -.09 1.18 2.63 2.63 0 0 1 -1.92 1.26 3.36 3.36 0 0 0 .33-.42z",
    fill: "#77e5c0"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m31.67 33 1.33 10.58a2.15 2.15 0 0 0 .18.61l4.16 9a1.35 1.35 0 0 1 -.09 1.18c-1.2 1.8-3.18 1.53-4 .28l-14.09-22.45z",
    fill: "none",
    stroke: "#041256",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.17 35.31 3.28-4.93a7.11 7.11 0 0 0 1.13-3l.42-3.04a3.18 3.18 0 0 1 1.71-2.4l.13-.06.13-.06 8-3.71a8.78 8.78 0 0 1 5.14-.7l4.52.75a7.11 7.11 0 0 1 2.66 1l6.52 4.16a.92.92 0 0 1 .32 1.2l-.62 1.19a.92.92 0 0 1 -1.18.42l-5.45-2.31a7.11 7.11 0 0 0 -3.14-.56l-3 .15 2.54 4.94a12.63 12.63 0 0 1 1.46 5.76 5.7 5.7 0 0 1 -4.61 5.66l-8.77 1.68 4 7.42a1.15 1.15 0 0 1 -.59 1.62l-.76.3a2.62 2.62 0 0 1 -3.01-.79l-6-7.45a4.11 4.11 0 0 1 .93-6l1.07-.74a27.64 27.64 0 0 1 5.57-2.81l-2.67-5-.46 1.26a7.11 7.11 0 0 1 -1.44 2.38l-5.34 5.64a.92.92 0 0 1 -1.24.1l-1.05-.83a.92.92 0 0 1 -.2-1.24z",
    fill: "#bdd2db"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m19.41 32.68-.12-.22 2.4-1.78a3.19 3.19 0 0 0 1.06-3.77 3.19 3.19 0 0 1 .08-2.6l.1-.2a3.19 3.19 0 0 1 2.87-1.8h2.48l.47 1.06-1 .05 2.54 4.94a12.63 12.63 0 0 1 1.46 5.76 5.68 5.68 0 0 1 -1 3.25l-1.33.15z",
    fill: "#96b5cc"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11.33 38.82 3.06-3.27a27.77 27.77 0 0 1 5.18-2.55l-1.35-2.54.35-.95 2.67 5a27.64 27.64 0 0 0 -5.6 2.82l-1.09.72a4.11 4.11 0 0 0 -.93 6l5.43 6.71a2.61 2.61 0 0 1 -1.05-.76l-6-7.45a4.08 4.08 0 0 1 -.76-3.63.88.88 0 0 0 .09-.1z",
    fill: "#d3e9f2"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18 20.64.31-.74s-.15 5.75 5.18 6.21a1.18 1.18 0 0 1 .81.41l1.3 1.58a.53.53 0 0 1 -.28.85l-2.05.52a1.12 1.12 0 0 1 -.68 0c-1.24-.53-5.59-2.66-4.59-8.83z",
    fill: "#041256"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12.88 36.53 1.12-.72a27.64 27.64 0 0 1 5.57-2.81 27.64 27.64 0 0 1 11.72-2 12.62 12.62 0 0 1 .44 3.16 5.7 5.7 0 0 1 -4.61 5.66l-8.77 1.68 4 7.42a1.15 1.15 0 0 1 -.59 1.62l-.76.3a2.62 2.62 0 0 1 -3-.84l-6-7.45a4.11 4.11 0 0 1 .88-6.02z",
    fill: "#53619b"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "#77e5c0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30 34.69a12.63 12.63 0 0 0 -1.46-5.76l-2.34-5.18 1.75.14 2.3 4.47a12.63 12.63 0 0 1 1.46 5.76 5.7 5.7 0 0 1 -4.61 5.66h-.25a5.69 5.69 0 0 0 3.15-5.09z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.39 25.09a.92.92 0 0 0 -.32-1.2l-6.52-4.16a7.11 7.11 0 0 0 -2.66-1l-4.52-.73a8.76 8.76 0 0 0 -3.43.13 8.78 8.78 0 0 1 5.14-.7l4.52.75a7.11 7.11 0 0 1 2.66 1l6.52 4.16a.92.92 0 0 1 .32 1.2l-.62 1.19a.92.92 0 0 1 -1.18.42l-.37-.15z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.52 49.94-4.17-8.26h1.12l3.89 7.21a1.15 1.15 0 0 1 -.59 1.62l-.76.3a2.61 2.61 0 0 1 -.83.18c.54-.3 1.64-.49 1.34-1.05z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.24 32.2a7.11 7.11 0 0 0 1.49-2.42l.46-1.26.81 1.59a7.11 7.11 0 0 1 -1 1.53l-5.34 5.64a.92.92 0 0 1 -1.24.1z",
    fill: "inherit"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12.88 36.53 1.12-.72a27.64 27.64 0 0 1 5.57-2.81 27.64 27.64 0 0 1 11.72-2c0 .11 0 .23.07.34a30.55 30.55 0 0 0 -8.75 2 27.64 27.64 0 0 0 -5.61 2.83l-2.31 1.53a2.77 2.77 0 0 0 -.63 4.06l7 8.62a2.62 2.62 0 0 0 .28.3l-.32.13a2.62 2.62 0 0 1 -3.02-.81l-6-7.45a4.11 4.11 0 0 1 .88-6.02z",
    fill: "#8da0db"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18.62 55.41 1.3-4.61 2.57-1.41 1.8 2.11a1 1 0 0 1 -.09 1.36l-3.88 3.53a1 1 0 0 1 -.93.24h-.07a1 1 0 0 1 -.7-1.22z",
    fill: "#041256"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m19.2 32a27.64 27.64 0 0 1 12.08-1 26.66 26.66 0 0 0 -11.36 2.9 1 1 0 1 1 -.92-1.81z",
    fill: "#041256"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#041256",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.17 35.31 3.28-4.93a7.11 7.11 0 0 0 1.13-3l.42-3.04a3.18 3.18 0 0 1 1.71-2.4l.13-.06.13-.06 8-3.71a8.78 8.78 0 0 1 5.14-.7l4.52.75a7.11 7.11 0 0 1 2.66 1l6.52 4.16a.92.92 0 0 1 .32 1.2l-.62 1.19a.92.92 0 0 1 -1.18.42l-5.45-2.31a7.11 7.11 0 0 0 -3.14-.56l-3 .15 2.54 4.94a12.63 12.63 0 0 1 1.46 5.76 5.7 5.7 0 0 1 -4.61 5.66l-8.77 1.68 4 7.42a1.15 1.15 0 0 1 -.59 1.62l-.76.3a2.62 2.62 0 0 1 -3.01-.79l-6-7.45a4.11 4.11 0 0 1 .93-6l1.07-.74a27.64 27.64 0 0 1 5.57-2.81l-2.67-5-.46 1.26a7.11 7.11 0 0 1 -1.44 2.38l-5.34 5.64a.92.92 0 0 1 -1.24.1l-1.05-.83a.92.92 0 0 1 -.2-1.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.38 28.87-.91-1.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.71 23.27-3.61.12"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m17.35 7.76h.95a2.82 2.82 0 0 1 2.82 2.82v4.52a4.59 4.59 0 0 1 -4.59 4.59 4.59 4.59 0 0 1 -4.59-4.59v-1.93a5.41 5.41 0 0 1 5.41-5.41z",
    fill: "#dda183",
    transform: "rotate(171.87 16.528 13.723)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m14.35 11.29 3.69-1 2.71.93.06.07.33 2.32a5.41 5.41 0 0 1 -2.88 5.57 6 6 0 0 0 -2.32-4l-2.11-1.6z",
    fill: "#d38d6e"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m15.68 7.82a4.59 4.59 0 0 1 1 0 4.59 4.59 0 0 0 -2.95 4.95l.64 4.48a2.81 2.81 0 0 0 2.81 2.41 5.45 5.45 0 0 1 -.61.12l-.94.13a2.82 2.82 0 0 1 -3.19-2.39l-.65-4.52a4.59 4.59 0 0 1 3.89-5.18z",
    fill: "#f2bea7"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m21.19 14.65a5.34 5.34 0 0 1 -.12.9v.07a5.4 5.4 0 0 1 -.28.87 5.48 5.48 0 0 1 -.44.82c-.67 0-1.13-.11-.83-.59.48-.78.19-2.25-.44-2.12s-.69 1.24-.69 1.24l-.59.16-.39-1.26a2 2 0 0 0 -2.3-1.31c-2 .47-3.17.62-3.34-.78v-.07c0-.06 0-.13 0-.19l.34-1.72a4.7 4.7 0 0 1 .25-.51v-.06a4.66 4.66 0 0 1 .55-.75l.17-.19.3-.27a4.59 4.59 0 0 1 .4-.3l.26-.16a4.55 4.55 0 0 1 .6-.29l.25-.14a3.41 3.41 0 0 1 3.44.59 6.93 6.93 0 0 1 2.77 4.68v.34a5.39 5.39 0 0 1 0 1s.09.01.09.04z",
    fill: "#041256"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m19.67 16.68a5.4 5.4 0 0 0 .28-.87v-.07a5.34 5.34 0 0 0 .12-.9s0-.05 0-.08a5.39 5.39 0 0 0 0-1v-.34a6.93 6.93 0 0 0 -2.77-4.68 3.76 3.76 0 0 0 -2.13-.81 3.39 3.39 0 0 1 3.22.65 6.93 6.93 0 0 1 2.77 4.68v.34a5.39 5.39 0 0 1 0 1s0 .05 0 .08a5.34 5.34 0 0 1 -.12.9v.07a5.4 5.4 0 0 1 -.28.87 5.48 5.48 0 0 1 -.44.82c-.44 0-.78 0-.89-.21.08-.13.17-.29.24-.45z",
    fill: "#77e5c0"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m17.35 7.76h.95a2.82 2.82 0 0 1 2.82 2.82v4.52a4.59 4.59 0 0 1 -4.59 4.59 4.59 4.59 0 0 1 -4.59-4.59v-1.93a5.41 5.41 0 0 1 5.41-5.41z",
    fill: "none",
    stroke: "#041256",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "rotate(171.87 16.528 13.723)"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m19.05 19.44a1.4 1.4 0 1 1 -2.51 1.17z",
    fill: "#041256"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m42.75 50a1.5 1.5 0 0 1 0-.15s0-.09 0-.13a1.53 1.53 0 0 1 0-.3 1.54 1.54 0 0 1 0-.3s0-.09 0-.13a.9.9 0 0 1 .13-.3l.06-.12a1.54 1.54 0 0 1 .19-.23l2.38-2.38a1.53 1.53 0 0 1 2.36 1.93h2.75a1.53 1.53 0 0 1 0 3.06h-2.8a1.53 1.53 0 0 1 -2.36 1.93l-2.38-2.38a1.54 1.54 0 0 1 -.19-.23l-.06-.11a1.51 1.51 0 0 1 -.08-.16z",
    fill: "#fff"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    fill: "#e593ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.57 11.69a.5.5 0 0 1 .5-.5h2.67a.83.83 0 0 1 .83.83.83.83 0 0 1 -.83.83h-1.33a.5.5 0 0 0 -.5.5.5.5 0 0 1 -.5.5h-2.67a.83.83 0 0 1 -.84-.85.83.83 0 0 1 .83-.83h1.33a.5.5 0 0 0 .51-.48z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.41 15.46a.29.29 0 0 0 -.29-.29h-1.55a.48.48 0 0 0 -.48.48.48.48 0 0 0 .48.48h.77a.29.29 0 0 1 .29.29.29.29 0 0 0 .29.29h1.55a.48.48 0 0 0 .48-.48.48.48 0 0 0 -.48-.48h-.77a.29.29 0 0 1 -.29-.29z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.11,
    cy: 23.37,
    fill: "inherit",
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.23,
    cy: 17.21,
    fill: "inherit",
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9,
    cy: 18.58,
    fill: "inherit",
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.25,
    cy: 10.21,
    fill: "inherit",
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.24,
    cy: 18.58,
    fill: "inherit",
    r: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.02,
    cy: 24.23,
    fill: "inherit",
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.38,
    cy: 15.56,
    fill: "inherit",
    r: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.23,
    cy: 30.9,
    fill: "inherit",
    r: 2.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.66,
    cy: 28.53,
    fill: "inherit",
    r: 1.77
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKickEveryoneOut);
export default __webpack_public_path__ + "static/media/kick-everyone-out.4d84cb0b92cddbcd10518b1d9a91addc.svg";
export { ForwardRef as ReactComponent };